export default class NumberFormatService{
    formatNumberToString(number, zeroDelimiter = ',', thousandsDelimiter = '') {
        let numberString = number.toString();
        numberString = numberString.replace('.', zeroDelimiter);

        return numberString;
    };

    formatStringToNumber(numberString, beforeZeroDelimiter = ',', beforeThousandsDelimiter = ''){
        let result = numberString.replace(beforeZeroDelimiter, '.');
        return result;
    }
}